import type { DictsysGermanInflectionScheme } from "./article-formats/dictsys";

export type WordClass = "noun" | "verb" | "adjective";

export function isWordClass(wordClass: string): wordClass is WordClass {
  return ["noun", "verb", "adjective"].includes(wordClass);
}

interface BaseSearchResult {
  wordClass: WordClass;
}

export interface ExactResult extends BaseSearchResult {
  lemma: string;
  priority: number;
  gender: "neutrum" | "femininum" | "maskulinum" | null;
  inflectionScheme: DictsysGermanInflectionScheme;
}

export interface FuzzyResult extends BaseSearchResult {
  word: string;
}

export type SearchResult = ExactResult | FuzzyResult;

interface BaseSearchResponse {
  type: "exact" | "fuzzy" | "empty";
  results: SearchResult[];
}

export interface ExactResponse extends BaseSearchResponse {
  type: "exact";
  results: ExactResult[];
}

export interface FuzzyResponse extends BaseSearchResponse {
  type: "fuzzy";
  results: FuzzyResult[];
}

export interface EmptyResponse extends BaseSearchResponse {
  type: "empty";
  results: [];
}

export type SearchResponse = ExactResponse | FuzzyResponse | EmptyResponse;

export type WordClassLabelSet = Record<WordClass, { danish: string; latin: string }>;

export interface FuzzySuggestions {
  suggestions: string[];
  wordClass: WordClass;
}
